import React from 'react';
import { Alert } from '@mui/material';
import { DevelopmentWarningBannerProps } from './types';
import { useDevelopmentWarningBanner } from './useDevelopmentWarningBanner';
import styles from './DevelopmentWarningBanner.module.scss';

const DevelopmentWarningBanner: React.FC<
  DevelopmentWarningBannerProps
> = () => {
  const { shouldShowWarning } = useDevelopmentWarningBanner();

  if (!shouldShowWarning) {
    return null;
  }

  return (
    <Alert severity="error" className={styles.warningBanner}>
      🚨 !!!! DANGER - DEVELOPMENT MODE WITH PRODUCTION DATABASE !!!! 🚨
    </Alert>
  );
};

export default DevelopmentWarningBanner;
